import React from "react";
import { withRouter } from "react-router-dom";
import { css, StyleSheet } from "aphrodite";
import { connect } from "react-redux";
import { snakeCase } from "lodash";
import moment from "moment";
import {
    parsePhoneNumber,
    getNumberType,
    isPossiblePhoneNumber,
    isValidPhoneNumber,
    validatePhoneNumberLength
} from 'libphonenumber-js';
import { Modal, Form, Button, Col, Row, Table, label, Badge, Card, Toast, ToastContainer } from "react-bootstrap";
import { callApi, validateToken } from "../../lib/utils";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import PhoneInput from "react-phone-input-2";
import SelectField from "../GenericComponents/SelectField";
import TextField from "../GenericComponents/TextField";
import CustomLoader from "../GenericComponents/CustomLoader";
import CustomRadioButton from "../GenericComponents/CustomRadioButton";
import Payment from "payment";
import styles from "./style";
import countryCodes from "../iso_country_codes.json";

class PayementMethods extends React.Component {
    constructor(props) {
        super();
        this.typeaheadRefCity = React.createRef();
        this.typeaheadRefState = React.createRef();
        this.typeaheadRefCountry = React.createRef();
        this.inputRef = React.createRef();
        this.state = {
            loading: false,
            validated: true,
            updateFlag: false,
            patientPaymentMethod: [],
            expiryMonths: [],
            expiryYears: [],
            show: false,
            msg: "",
            paymentId: "",
            popupFlag: false,
            countryCodesArr: [],
            formInputs: {
                cardHolderName: '',
                cardNumber: '',
                cardType: "",
                cvc: '',
                expiryMonth: '',
                expiryYear: "",
                focus: '',
                //billingInfoType: "",
                // name: "",
                // phoneNumber: "",
                address: "",
                localityaddress: "",
                zipCode: "",
                city: "",
                initCities: [],
                cities: [],
                state: "",
                initStates: [],
                states: [],
                country: "",
                initCountries: [],
                countries: [],
                paymentMethodType: "1",
                setAsDefault: false
            },
            formValidations: {
                cardNumber: {
                    required: true,
                },
                cardHolderName: {
                    required: true,
                },
                cardType: {
                    required: true,
                },
                cvc: {
                    required: true,
                },
                expiryMonth: {
                    required: true,
                },
                expiryYear: {
                    required: true,
                },
                focus: {
                    required: false,
                },
                // name: {
                //     required: true,
                // },
                // phoneNumber: {
                //     required: false,
                // },
                address: {
                    required: true,
                },
                localityaddress: {
                    required: false
                },
                // billingInfoType: {
                //     required: true,
                // },
                zipCode: {
                    required: true,
                },
                city: {
                    required: true,
                },
                state: {
                    required: true,
                },
                country: {
                    required: true,
                },
                initCities: {
                    required: false,
                },
                cities: {
                    required: false,
                },
                initStates: {
                    required: false,
                },
                states: {
                    required: false,
                },
                initCountries: {
                    required: false,
                },
                countries: {
                    required: false,
                },
                paymentMethodType: {
                    required: false,
                },
                setAsDefault: {
                    required: false,
                },
            },
        };
    }

    componentDidMount = () => {
        let expiryMonths = [];
        let expiryYears = [];
        for (let index = 0; index < 12; index++) {
            let digit = ('0' + (index + 1)).slice(-2);
            expiryMonths.push({ id: digit, name: digit });
        }

        for (let curYr = new Date().getFullYear(), i = curYr; curYr + 20 > i; i++) {
            expiryYears.push({ id: i, name: i });
        }

        let countryCodesArr = [];
        countryCodes.map((val) => {
            let code = {
                id: val.code,
                name: val.countryName
            };
            countryCodesArr.push(code);
        })

        this.setState({ expiryMonths, expiryYears, countryCodesArr })
        this.fetchPaymentMethodData();
    }

    fetchPaymentMethodData = () => {
        this.setState({
            loading: true,
        });

        callApi(`/api/orders/payment-methods/${this.props.profileData.id}`, {}, "GET")
            .then((response) => {
                let patientPaymentMethod = response.data.data.paymentMethods;
                let activePaymentMethod = patientPaymentMethod.find((x) => x.status === "ACTIVE");

                this.setState({
                    patientPaymentMethod,
                    paymentId: activePaymentMethod.id,
                    loading: false
                })
            })
            .catch((err) => {
                console.log("err: ", err);
                this.setState({
                    loading: false,
                });
            });
    }

    handleChange = (e) => {
        let fieldName = e.target.name;
        let fieldValue = e.target.value;
        let formInputs = { ...this.state.formInputs };
        let formValidations = { ...this.state.formValidations };

        if (fieldName === "cardNumber") {
            let cardObj = this.formatCreditCardNumber(fieldValue);
            fieldValue = cardObj.value !== undefined ? cardObj.value : "";
            formInputs['cardType'] = (cardObj.cardType !== null && cardObj.cardType !== undefined) ? (cardObj.cardType).charAt(0).toUpperCase() + (cardObj.cardType).slice(1) : "";
        }
        else
            if (fieldName === "expiryMonth") {
                fieldValue = this.formatExpirationMonth(fieldValue);
            }
            else if (fieldName === "expiryYear") {
                fieldValue = this.formatExpirationYear(fieldValue);
            }
            else if (fieldName === "cvc") {
                fieldValue = this.formatCVC(fieldValue);
            }

        formInputs[fieldName] = fieldValue;
        this.setState({
            formInputs,
            formValidations
        },
            () => {
                this.setValidated(formInputs);
            })
    };

    validateExpiryDate = (e) => {
        let formInputs = { ...this.state.formInputs };
        let formValidations = { ...this.state.formValidations };
        let popupFlag = false;
        let yrSelected = formInputs.expiryYear;
        let monthSelected = formInputs.expiryMonth;
        if (yrSelected && monthSelected) {
            let curYr = new Date().getFullYear();
            let curMonth = new Date().getMonth() + 1;
            if (yrSelected == curYr && curMonth > monthSelected) {
                formInputs.expiryMonth = "";
                popupFlag = true;
            }
        }
        //formInputs[fieldName] = fieldValue;
        this.setState({
            popupFlag,
            formInputs,
            formValidations
        },
            () => {
                this.setValidated(formInputs);
            })
    };

    setValidated = (formInputs) => {
        let validated = false;
        let formValidations = { ...this.state.formValidations };

        for (let fieldName in formInputs) {
            let validationObj = formValidations[fieldName];
            let val = "";
            if (formInputs[fieldName] !== null)
                val = formInputs[fieldName].toString();

            if (validationObj.required && val.trim() === "") {
                validated = true;
                break;
            }
        }
        this.setState({ validated })
    };

    clearNumber = (value = "") => {
        return value.replace(/\D+/g, "");
    }

    formatCreditCardNumber = (value) => {
        if (!value) {
            return value;
        }

        const issuer = Payment.fns.cardType(value);
        const clearValue = this.clearNumber(value);
        let nextValue;

        //this.setCardType(issuer);

        switch (issuer) {
            case "amex":
                nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
                    4,
                    10
                )} ${clearValue.slice(10, 15)}`;
                break;
            case "dinersclub":
                nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
                    4,
                    10
                )} ${clearValue.slice(10, 14)}`;
                break;
            default:
                nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
                    4,
                    8
                )} ${clearValue.slice(8, 12)} ${clearValue.slice(12, 16)}`;
                break;
        }

        let returnObj = { value: nextValue.trim(), cardType: issuer };
        return (returnObj);
    }

    formatExpirationMonth = (value) => {
        const clearValue = this.clearNumber(value);
        return clearValue;
    }

    formatExpirationYear = (value) => {
        const clearValue = this.clearNumber(value);
        return clearValue;
    }

    formatCVC = (value, prevValue, allValues = {}) => {
        const clearValue = this.clearNumber(value);
        let maxLength = 3;

        if (allValues.number) {
            const issuer = Payment.fns.cardType(allValues.number);
            maxLength = issuer === "amex" ? 4 : 3;
        }

        return clearValue.slice(0, maxLength);
    }

    setZipcodeDetails = (e) => {
        let formInputs = { ...this.state.formInputs };
        // formInputs[fieldName] = fieldValue;
        validateToken((err) => {
            if (err) {
                window.location = "/logout";
            }
            if (
                formInputs.zipCode !== null &&
                formInputs.zipCode !== ""
                // &&
                // formInputs.zipCode !== this.state.oldZipcode
            ) {
                this.setState({
                    loading: true,
                });
                callApi(`/api/zipcode/details/${formInputs.zipCode}`, {}, "GET")
                    .then((response) => {
                        let result = response.data.data.zipCodes;
                        if (response.status === 200) {
                            if (result !== 0) {
                                let cities = [];
                                let states = [];
                                let countries = [];
                                let oldZipcode = formInputs.zipCode;

                                result.forEach((val) => {
                                    cities.push({
                                        id: val.postalLocation,
                                        name: val.postalLocation,
                                    });
                                    states.push({
                                        id: val.stateId,
                                        name: val.state,
                                    });
                                    countries.push({
                                        id: val.country,
                                        name: val.country,
                                    });
                                });

                                const uniqueStates = [];
                                states.forEach((item) => {
                                    var findItem = uniqueStates.find((x) => x.id === item.id);
                                    if (!findItem) uniqueStates.push(item);
                                });
                                const uniqueCountries = [];
                                countries.forEach((item) => {
                                    var findItem = uniqueCountries.find((x) => x.id === item.id);
                                    if (!findItem) uniqueCountries.push(item);
                                });

                                formInputs["country"] =
                                    uniqueCountries.length === 1
                                        ? uniqueCountries[0].id
                                        : formInputs.country;
                                formInputs["city"] =
                                    cities.length === 1
                                        ? cities[0].id
                                        : formInputs.city;
                                formInputs["initCities"] = cities;
                                formInputs["cities"] = cities;
                                formInputs["state"] =
                                    uniqueStates.length === 1
                                        ? uniqueStates[0].id
                                        : formInputs.state;
                                formInputs["initStates"] = uniqueStates;
                                formInputs["states"] = uniqueStates;
                                formInputs["initCountries"] = uniqueCountries;
                                formInputs["countries"] = uniqueCountries;
                                this.setState({
                                    loading: false,
                                    formInputs,
                                    oldZipcode,
                                });
                            }
                        } else {
                            this.setState({
                                loading: false,
                            });
                        }
                    })
                    .catch((err) => {
                        console.log("err: ", err);
                        this.setState({
                            loading: false,
                        });
                    });

                // this.setState({
                //   formInputs
                // })
            }
        });
    };

    handleCitySearch = (keyword) => {
        const formInputs = this.state.formInputs;
        const cities = this.state.formInputs.initCities.filter((item) => {
            return item.name.toLowerCase().includes(keyword.toLowerCase().trim());
        });
        formInputs.cities = cities;
        this.setState({ formInputs });
    };

    setCity = (data) => {
        if (data?.length) {
            const formInputs = this.state.formInputs;
            formInputs.city = data[0].name;
            this.setState({ formInputs });
        }
    };

    handleCityChange = () => {
        let formInputs = { ...this.state.formInputs };
        formInputs.city = this.typeaheadRefCity.current.inputNode.value;
        this.setState({ formInputs });
    };

    handleStateSearch = (keyword) => {
        const formInputs = this.state.formInputs;
        const states = this.state.formInputs.initStates.filter((item) => {
            return item.name.toLowerCase().includes(keyword.toLowerCase().trim());
        });
        formInputs.states = states;
        this.setState({ formInputs });
    };

    setStateValue = (data) => {
        if (data?.length) {
            const formInputs = this.state.formInputs;
            formInputs.state = data[0].id;
            this.setState({ formInputs });
        }
    };

    handleStateChange = () => {
        let formInputs = { ...this.state.formInputs };
        formInputs.state = this.typeaheadRefState.current.inputNode.value;
        this.setState({ formInputs });
    };

    handleCountrySearch = (keyword) => {
        const formInputs = this.state.formInputs;
        const countries = this.state.formInputs.initCountries.filter((item) => {
            return item.name.toLowerCase().includes(keyword.toLowerCase().trim());
        });
        formInputs.countries = countries;
        this.setState({ formInputs });
    };

    setCountry = (data) => {
        if (data?.length) {
            const formInputs = this.state.formInputs;
            formInputs.country = data[0].id;
            this.setState({ formInputs });
        }
    };

    handleCountryChange = () => {
        let formInputs = { ...this.state.formInputs };
        formInputs.country = this.typeaheadRefCountry.current.inputNode.value;
        this.setState({ formInputs });
    };

    // setPhoneNumber = (data, country) => {
    //     let formInputs = { ...this.state.formInputs };
    //     let isValidPhone = this.phoneValidation(data, country);
    //     formInputs.phoneNumber = data;
    //     this.setState({
    //         formInputs,
    //         isValidPhone
    //     });
    // };

    changeSetDefault = () => {
        let formInputs = { ...this.state.formInputs };
        formInputs.setAsDefault = !this.state.formInputs.setAsDefault;
        this.setState({ formInputs })
    }

    // phoneValidation = (value, country) => {
    //     try {
    //         let parsedPhoneNumber = parsePhoneNumber(`+${value}`, country.countryCode.toUpperCase());
    //         if (parsedPhoneNumber.isValid()) {
    //             return true;
    //         } else {
    //             return false;
    //         }
    //     } catch (e) {
    //         console.log("Parsing Error: ", e.message);
    //     }
    // }

    addNewCard = () => {
        let formInputs = { ...this.state.formInputs };
        formInputs.paymentMethodType = "2";
        this.setState({ formInputs })
    }

    setActiveCard = (paymentMethods) => {
        let formInputs = { ...this.state.formInputs };
        formInputs.paymentMethodType = "1";
        let paymentId = paymentMethods.id;
        this.setState({ formInputs, paymentId })
    }

    saveNewCard = () => {
        let formInputs = { ...this.state.formInputs };

        let params = {
            cardType: formInputs.cardType,
            cardNumber: formInputs.cardNumber,
            expiryMonth: parseInt(formInputs.expiryMonth),
            expiryYear: parseInt(formInputs.expiryYear),
            cvc: formInputs.cvc,
            customerName: formInputs.cardHolderName,
            addressLine1: formInputs.address,
            addressLine2: formInputs.localityaddress,
            city: formInputs.city,
            state: formInputs.state,
            country: formInputs.country,
            zipcode: formInputs.zipCode,
            phoneNumber: null,
            setAsDefault: formInputs.setAsDefault
        }

        this.setState({
            loading: true,
        });

        callApi(`/api/orders/payment-methods/${this.props.profileData.id}`, params, "POST")
            .then((response) => {
                this.setState({
                    loading: false,
                    show: true,
                    msg: "Added a new card successfully"
                })
            })
            .catch((err) => {
                console.log("err: ", err);
                this.setState({
                    loading: false,
                    show: true,
                    msg: err.message ? err.message : "something went wrong, while adding new payment method !"
                });
            });
    }

    handleClose = () => {
        let formInputs = { ...this.state.formInputs };
        formInputs.setAsDefault = false;
        formInputs.paymentMethodType = "1";
        this.setState({ show: !this.state.show, formInputs }, () => this.fetchPaymentMethodData())
    }

    setShow = (val) => {
        this.setState({ popupFlag: val })
    }

    close = () => {
        this.props.history.push("/dashboard");
    };

    render() {
        const { patientPaymentMethod, formInputs } = this.state;
        return (
            <div>
                <div className={css(style.header)}>
                    <div className={css(style.title)}>{"Payment Methods"}</div>
                    <div className={css(style.divContainer)}>
                        <div className={css(style.divIcon)}>
                            <span
                                className={css(style.iconsMenu)}
                                title="Close"
                                onClick={this.close}
                            >
                                <img
                                    className={css(style.imageiconsMenu)}
                                    alt="close"
                                    src="/images/close_icon.png"
                                />
                            </span>
                        </div>
                    </div>
                </div>
                <CustomLoader loading={this.state.loading} />
                <ToastContainer
                    className="p-3"
                    position={"top-end"}
                    style={{ zIndex: 999 }}
                >
                    <Toast bg="info" onClose={() => this.setShow(false)} show={this.state.popupFlag} delay={6000} autohide>
                        <Toast.Header className={css(styles.toastHeader)}>
                            {"Expiry month can't be before present month"}
                        </Toast.Header>
                    </Toast>
                </ToastContainer>
                <Modal
                    size="sm"
                    show={this.state.show}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Body>
                        <p>{this.state.msg}</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={this.handleClose}>
                            Ok
                        </Button>
                    </Modal.Footer>
                </Modal>
                <div style={{ textAlign: "end", color: "red", padding: "1em" }}>{"* SmartMonitor does not store any credit card details on our website."}</div>
                <div style={{ padding: "0em 2em" }}>
                    <Row>
                        <Col md={2}>
                            <div style={{ textAlign: "center" }}>
                                <Button
                                    variant="primary"
                                    type="button"
                                    style={{ width: "100%" }}
                                    onClick={this.addNewCard}
                                >
                                    {"Add a Card"}
                                </Button>
                            </div>
                            <hr />
                            <Card>
                                <Card.Header className={css(styles.cardStyle)}>Cards</Card.Header>
                                {patientPaymentMethod.length !== 0 ?
                                    patientPaymentMethod.sort((a, b) => {
                                        if (a.status === "ACTIVE") {
                                            return -1;
                                        } else {
                                            return 1;
                                        }
                                    }).map((payment) => {
                                        return <Card.Body>
                                            <Card.Text className={css(styles.leftLabels)}>
                                                <div style={{ cursor: "pointer" }} onClick={() => this.setActiveCard(payment)}><span> {`**** **** **** ${payment.last4}`}</span>
                                                    <i className="fa fa-circle pull-right" style={payment?.status === 'INACTIVE' ? { color: "red" } : { color: "green" }}></i><br />
                                                </div>
                                            </Card.Text>
                                        </Card.Body>
                                    })
                                    : <Card.Body>
                                        <Card.Text>
                                            <label>{`No Cards in your Wallet`}</label>
                                        </Card.Text>
                                    </Card.Body>}
                            </Card>
                        </Col>
                        {formInputs.paymentMethodType === "1" ?
                            patientPaymentMethod.filter((val) => {
                                return val.id === this.state.paymentId;
                            }).map((payment) =>
                                <Col md={10} className="mb-4" style={{ padding: "2em 3em", border: "2px #0dcaf0 solid" }}>
                                    <Row>
                                        <Col md={6}>
                                            <Form.Group
                                                as={Row}
                                                className={css(styles.fieldMargin)}
                                            >
                                                <Form.Label column md={5} className={css(styles.horizontallabels)}>
                                                    Credit Card Number {formInputs.paymentMethodType !== "1" ? <span style={{ color: "red" }}>*</span> : " :"}
                                                </Form.Label>
                                                <Col md={7}>
                                                    <div><label>{`**** **** **** ${payment.last4}`}</label></div>
                                                </Col>
                                            </Form.Group>

                                            <Form.Group
                                                as={Row}
                                                className={css(styles.fieldMargin)}
                                            >
                                                <Form.Label column md={5} className={css(styles.horizontallabels)}>
                                                    Name on Card {formInputs.paymentMethodType !== "1" ? <span style={{ color: "red" }}>*</span> : " :"}
                                                </Form.Label>
                                                <Col md={7}>
                                                    <div><label>{payment.customerName}</label></div>
                                                </Col>
                                            </Form.Group>
                                        </Col>

                                        <Col md={6}>
                                            <Form.Group
                                                as={Row}
                                                className={css(styles.fieldMargin)}
                                            >
                                                <Form.Label column md={5} className={css(styles.horizontallabels)}>
                                                    Card Expiry Month & Year {formInputs.paymentMethodType !== "1" ? <span style={{ color: "red" }}>*</span> : " :"}
                                                </Form.Label>
                                                <Col md={7}><label>{`${payment.expiryMonth} / ${payment.expiryYear}`}</label></Col>
                                            </Form.Group>

                                            {payment.status === "ACTIVE" &&
                                                <Form.Group
                                                    as={Row}
                                                    className={css(styles.fieldMargin)}
                                                >
                                                    <Form.Label column md={5} className={css(styles.horizontallabels)}>
                                                        Set as Default
                                                    </Form.Label>
                                                    <Col md={7}>
                                                        <CustomRadioButton
                                                            type={"switch"}
                                                            inline={true}
                                                            label={""}
                                                            checked={true}
                                                            //action={this.changeSetDefault}
                                                            disabled={true}
                                                        />
                                                    </Col>
                                                </Form.Group>
                                            }
                                        </Col>
                                    </Row>

                                    {/* <hr />
                                    <div style={{
                                        textAlign: "center",
                                        textTransform: "uppercase",
                                        fontSize: "11px",
                                        color: "#3ea784"
                                    }}>{"billing information corresponding to the card"}</div>

                                    <Row className="mb-4">
                                        <Col>
                                            <Form.Group
                                                as={Row}
                                                className={css(styles.fieldMargin)}
                                            >
                                                <Form.Label column md={5} className={css(styles.horizontallabels)}>
                                                    Address {formInputs.paymentMethodType !== "1" ? <span style={{ color: "red" }}>*</span> : " :"}
                                                </Form.Label>
                                                <Col md={6}>
                                                    <div><label>{payment.addressLine1}</label></div>
                                                </Col>
                                            </Form.Group>

                                            <Form.Group
                                                as={Row}
                                                className={css(styles.fieldMargin)}
                                            >
                                                <Form.Label column md={5} className={css(styles.horizontallabels)}>
                                                    Address(line2) {formInputs.paymentMethodType !== "1" ? "" : " :"}
                                                </Form.Label>
                                                <Col md={6}>
                                                    <div><label>{payment.addressLine2}</label></div>
                                                </Col>
                                            </Form.Group>
                                        </Col>

                                        <Col>
                                            <Form.Group as={Row}
                                                className={css(styles.fieldMargin)}>
                                                <Form.Label column md={5} className={css(styles.horizontallabels)}>
                                                    Zipcode {formInputs.paymentMethodType !== "1" ? <span style={{ color: "red" }}>*</span> : " :"}
                                                </Form.Label>
                                                <Col md={6}>
                                                    <div><label>{payment.zipcode}</label></div>
                                                </Col>
                                            </Form.Group>
                                            <Form.Group as={Row}
                                                className={css(styles.fieldMargin)}>
                                                <Form.Label column md={5} className={css(styles.horizontallabels)}>
                                                    City {formInputs.paymentMethodType !== "1" ? <span style={{ color: "red" }}>*</span> : " :"}
                                                </Form.Label>
                                                <Col md={6}>
                                                    <div><label>{payment.city}</label></div>
                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Row}
                                                className={css(styles.fieldMargin)}>
                                                <Form.Label column md={5} className={css(styles.horizontallabels)}>
                                                    State {formInputs.paymentMethodType !== "1" ? <span style={{ color: "red" }}>*</span> : " :"}
                                                </Form.Label>
                                                <Col md={6}>
                                                    <div><label>{payment.state}</label></div>
                                                </Col>

                                            </Form.Group>
                                            <Form.Group as={Row}
                                                className={css(styles.fieldMargin)}>
                                                <Form.Label column md={5} className={css(styles.horizontallabels)}>
                                                    Country {formInputs.paymentMethodType !== "1" ? <span style={{ color: "red" }}>*</span> : " :"}
                                                </Form.Label>
                                                <Col md={6}>
                                                    <div><label>{payment.country}</label></div>
                                                </Col>
                                            </Form.Group>
                                        </Col>
                                    </Row> */}
                                </Col>
                            )
                            :
                            <Col md={10} className="mb-4" style={{ padding: "2em 3em", border: "2px #0dcaf0 solid" }}>
                                <Row>
                                    <Col md={6}>
                                        <Form.Group
                                            as={Row}
                                            className={css(styles.fieldMargin)}
                                        >
                                            <Form.Label column md={5} className={css(styles.horizontallabels)}>
                                                Credit Card Number {formInputs.paymentMethodType !== "1" ? <span style={{ color: "red" }}>*</span> : " :"}
                                            </Form.Label>
                                            <Col md={7}>
                                                <TextField
                                                    type={"text"}
                                                    placeholder={"Card Number"}
                                                    name={"cardNumber"}
                                                    value={formInputs.cardNumber}
                                                    action={this.handleChange}
                                                    //isNumber={true}
                                                    required={true}
                                                    readOnly={false}
                                                />
                                            </Col>
                                        </Form.Group>

                                        <Form.Group
                                            as={Row}
                                            className={css(styles.fieldMargin)}
                                        >
                                            <Form.Label column md={5} className={css(styles.horizontallabels)}>
                                                Name on Card {formInputs.paymentMethodType !== "1" ? <span style={{ color: "red" }}>*</span> : " :"}
                                            </Form.Label>
                                            <Col md={7}>
                                                <TextField
                                                    type={"text"}
                                                    placeholder={"Card Holder Name"}
                                                    name={"cardHolderName"}
                                                    value={formInputs.cardHolderName}
                                                    action={this.handleChange}
                                                    isAlphaNumeric={true}
                                                    required={true}
                                                    readOnly={false}
                                                />
                                            </Col>
                                        </Form.Group>

                                        <Form.Group
                                            as={Row}
                                            className={css(styles.fieldMargin)}
                                        >
                                            <Form.Label column md={5} className={css(styles.horizontallabels)}>
                                                Type of Card {formInputs.paymentMethodType !== "1" ? <span style={{ color: "red" }}>*</span> : " :"}
                                            </Form.Label>
                                            <Col md={7}>
                                                <TextField
                                                    type={"text"}
                                                    placeholder={"Type of Card"}
                                                    name={"cardType"}
                                                    value={formInputs.cardType}
                                                    action={this.handleChange}
                                                    //isAlphaNumeric={true}
                                                    required={true}
                                                    readOnly={false}
                                                />
                                            </Col>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group
                                            as={Row}
                                            className={css(styles.fieldMargin)}
                                        >
                                            <Form.Label column md={5} className={css(styles.horizontallabels)}>
                                                Card Expiry Month & Year {formInputs.paymentMethodType !== "1" ? <span style={{ color: "red" }}>*</span> : " :"}
                                            </Form.Label>
                                            <>
                                                <Col md={2}>
                                                    <SelectField
                                                        name={"expiryMonth"}
                                                        options={this.state.expiryMonths}
                                                        value={formInputs.expiryMonth}
                                                        defaultValue={""}
                                                        action={this.handleChange}
                                                        onBlurAction={this.validateExpiryDate}
                                                        required={true}
                                                    />
                                                </Col>
                                                <Col md={5}>
                                                    <SelectField
                                                        name={"expiryYear"}
                                                        options={this.state.expiryYears}
                                                        value={formInputs.expiryYear}
                                                        defaultValue={""}
                                                        action={this.handleChange}
                                                        onBlurAction={this.validateExpiryDate}
                                                        required={true}
                                                    />
                                                </Col>
                                            </>
                                        </Form.Group>

                                        <Form.Group
                                            as={Row}
                                            className={css(styles.fieldMargin)}
                                        >
                                            <Form.Label column md={5} className={css(styles.horizontallabels)}>
                                                Security Code {formInputs.paymentMethodType !== "1" ? <span style={{ color: "red" }}>*</span> : " :"}
                                            </Form.Label>
                                            <Col md={7}>
                                                <TextField
                                                    type={"text"}
                                                    placeholder={"cvc"}
                                                    name={"cvc"}
                                                    value={formInputs.cvc}
                                                    action={this.handleChange}
                                                    //isNumber={true}
                                                    required={true}
                                                    readOnly={false}
                                                />
                                            </Col>
                                        </Form.Group>

                                        <Form.Group
                                            as={Row}
                                            className={css(styles.fieldMargin)}
                                            style={{ display: "flex", alignItems: "center" }}
                                        >
                                            <Form.Label column md={5} className={css(styles.horizontallabels)}>
                                                Set as Default
                                            </Form.Label>
                                            <Col md={7}>
                                                <CustomRadioButton
                                                    type={"switch"}
                                                    inline={true}
                                                    label={""}
                                                    checked={formInputs.setAsDefault}
                                                    action={this.changeSetDefault}

                                                />
                                            </Col>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <hr />
                                <div style={{
                                    textAlign: "center",
                                    textTransform: "uppercase",
                                    fontSize: "11px",
                                    color: "#3ea784"
                                }}>{"billing information corresponding to the card"}</div>

                                <Row className="mb-4">
                                    <Col>
                                        <Form.Group
                                            as={Row}
                                            className={css(styles.fieldMargin)}
                                        >
                                            <Form.Label column md={5} className={css(styles.horizontallabels)}>
                                                Address {formInputs.paymentMethodType !== "1" ? <span style={{ color: "red" }}>*</span> : " :"}
                                            </Form.Label>
                                            <Col md={6}>
                                                <TextField
                                                    type={"text"}
                                                    placeholder={"Address for Billing"}
                                                    name={"address"}
                                                    value={formInputs.address}
                                                    action={this.handleChange}
                                                    isAlphaNumeric={true}
                                                    required={true}
                                                />
                                            </Col>
                                        </Form.Group>

                                        <Form.Group
                                            as={Row}
                                            className={css(styles.fieldMargin)}
                                        >
                                            <Form.Label column md={5} className={css(styles.horizontallabels)}>
                                                Address(line2) {formInputs.paymentMethodType !== "1" ? "" : " :"}
                                            </Form.Label>
                                            <Col md={6}>
                                                <TextField
                                                    type={"text"}
                                                    placeholder={"Address(line2)"}
                                                    name={"localityaddress"}
                                                    value={formInputs.localityaddress}
                                                    action={this.handleChange}
                                                    isAlphaNumeric={true}
                                                    required={false}
                                                />
                                            </Col>
                                        </Form.Group>

                                        <Form.Group as={Row}
                                            className={css(styles.fieldMargin)}>
                                            <Form.Label column md={5} className={css(styles.horizontallabels)}>
                                                Zipcode {formInputs.paymentMethodType !== "1" ? <span style={{ color: "red" }}>*</span> : " :"}
                                            </Form.Label>
                                            <Col md={6}>
                                                <TextField
                                                    type={"text"}
                                                    placeholder={"Enter Zipcode"}
                                                    name={"zipCode"}
                                                    value={this.state.formInputs.zipCode}
                                                    action={this.handleChange}
                                                    //onBlurAction={this.setZipcodeDetails}
                                                    isZipcode={true}
                                                    required={true}
                                                />
                                            </Col>
                                        </Form.Group>
                                    </Col>

                                    <Col>
                                        <Form.Group as={Row}
                                            className={css(styles.fieldMargin)}>
                                            <Form.Label column md={5} className={css(styles.horizontallabels)}>
                                                City {formInputs.paymentMethodType !== "1" ? <span style={{ color: "red" }}>*</span> : " :"}
                                            </Form.Label>
                                            <Col md={6}>
                                                <TextField
                                                    type={"text"}
                                                    placeholder={"Enter City..."}
                                                    name={"city"}
                                                    value={formInputs.city}
                                                    action={this.handleChange}
                                                    isAlphaNumeric={true}
                                                    required={true}
                                                />
                                                {/* {!!formInputs.initCities.length && formInputs.paymentMethodType !== "1" && (
                                                    <AsyncTypeahead
                                                        defaultSelected={formInputs.initCities.filter(
                                                            (item) => {
                                                                return item.name === formInputs.city;
                                                            }
                                                        )}
                                                        isLoading={false}
                                                        defaultInputValue={formInputs.city}
                                                        filterBy={() => true}
                                                        id="async-city"
                                                        labelKey="name"
                                                        ref={this.typeaheadRefCity}
                                                        minLength={2}
                                                        onSearch={this.handleCitySearch}
                                                        onChange={this.setCity}
                                                        options={formInputs.cities}
                                                        placeholder="Enter City..."
                                                        inputProps={{ required: true }}
                                                        onInputChange={this.handleCityChange}
                                                        onBlur={this.handleCityChange}
                                                    ></AsyncTypeahead>
                                                )}
                                                {!formInputs.initCities.length && formInputs.paymentMethodType !== "1" && (
                                                    <AsyncTypeahead
                                                        // defaultSelected={this.state.formInputs.initCities.filter((item)=>{
                                                        //   return item.name === this.state.formInputs.city
                                                        // })}
                                                        defaultInputValue={formInputs.city}
                                                        isLoading={false}
                                                        filterBy={() => true}
                                                        id="async-city"
                                                        labelKey="name"
                                                        ref={this.typeaheadRefCity}
                                                        minLength={2}
                                                        onSearch={this.handleCitySearch}
                                                        onChange={this.setCity}
                                                        options={formInputs.cities}
                                                        placeholder="Enter City..."
                                                        inputProps={{ required: true }}
                                                        onInputChange={this.handleCityChange}
                                                        onBlur={this.handleCityChange}
                                                    ></AsyncTypeahead>
                                                )} */}
                                            </Col>
                                        </Form.Group>

                                        <Form.Group as={Row}
                                            className={css(styles.fieldMargin)}>
                                            <Form.Label column md={5} className={css(styles.horizontallabels)}>
                                                State {formInputs.paymentMethodType !== "1" ? <span style={{ color: "red" }}>*</span> : " :"}
                                            </Form.Label>
                                            <Col md={6}>
                                                <TextField
                                                    type={"text"}
                                                    placeholder={"Enter State..."}
                                                    name={"state"}
                                                    value={formInputs.state}
                                                    action={this.handleChange}
                                                    isAlphaNumeric={true}
                                                    required={true}
                                                />
                                                {/* {!!formInputs.initStates.length && formInputs.paymentMethodType !== "1" && (
                                                    <AsyncTypeahead
                                                        // defaultSelected={this.state.formInputs.states.filter((item)=>{
                                                        //   return item.id === this.state.formInputs.state
                                                        // })}
                                                        isLoading={false}
                                                        defaultInputValue={formInputs.state}
                                                        filterBy={() => true}
                                                        id="async-state"
                                                        labelKey="name"
                                                        ref={this.typeaheadRefState}
                                                        minLength={2}
                                                        onSearch={this.handleStateSearch}
                                                        onChange={this.setStateValue}
                                                        options={formInputs.states}
                                                        placeholder="Enter State..."
                                                        inputProps={{ required: true }}
                                                        onInputChange={this.handleStateChange}
                                                        onBlur={this.handleStateChange}
                                                    ></AsyncTypeahead>
                                                )}
                                                {!formInputs.initStates.length && formInputs.paymentMethodType !== "1" && (
                                                    <AsyncTypeahead
                                                        // defaultSelected={this.state.formInputs.states.filter((item)=>{
                                                        //   return item.id === this.state.formInputs.state
                                                        // })}
                                                        defaultInputValue={formInputs.state}
                                                        isLoading={false}
                                                        filterBy={() => true}
                                                        id="async-state"
                                                        labelKey="name"
                                                        ref={this.typeaheadRefState}
                                                        minLength={2}
                                                        onSearch={this.handleStateSearch}
                                                        onChange={this.setStateValue}
                                                        options={formInputs.states}
                                                        placeholder="Enter State..."
                                                        inputProps={{ required: true }}
                                                        onInputChange={this.handleStateChange}
                                                        onBlur={this.handleStateChange}
                                                    ></AsyncTypeahead>
                                                )} */}
                                            </Col>

                                        </Form.Group>
                                        <Form.Group as={Row}
                                            className={css(styles.fieldMargin)}>
                                            <Form.Label column md={5} className={css(styles.horizontallabels)}>
                                                Country {formInputs.paymentMethodType !== "1" ? <span style={{ color: "red" }}>*</span> : " :"}
                                            </Form.Label>
                                            <Col md={6}>
                                                <SelectField
                                                    name={"country"}
                                                    options={this.state.countryCodesArr}
                                                    value={formInputs.country}
                                                    defaultValue={""}
                                                    action={this.handleChange}
                                                    required={true}
                                                />
                                                {/* {!!formInputs.initCountries.length && formInputs.paymentMethodType !== "1" && (
                                                    <AsyncTypeahead
                                                        // defaultSelected={this.state.formInputs.countries.filter((item)=>{
                                                        //   return item.id === this.state.formInputs.country
                                                        // })}
                                                        isLoading={false}
                                                        defaultInputValue={formInputs.country}
                                                        filterBy={() => true}
                                                        id="async-country"
                                                        labelKey="name"
                                                        ref={this.typeaheadRefCountry}
                                                        minLength={2}
                                                        onSearch={this.handleCountrySearch}
                                                        onChange={this.setCountry}
                                                        options={formInputs.countries}
                                                        placeholder="Enter Country..."
                                                        inputProps={{ required: true }}
                                                        onInputChange={this.handleCountryChange}
                                                        onBlur={this.handleCountryChange}
                                                    ></AsyncTypeahead>
                                                )}
                                                {!formInputs.initCountries.length && formInputs.paymentMethodType !== "1" && (
                                                    <AsyncTypeahead
                                                        // defaultSelected={this.state.formInputs.countries.filter((item)=>{
                                                        //   return item.id === this.state.formInputs.country
                                                        // })}
                                                        defaultInputValue={formInputs.country}
                                                        isLoading={false}
                                                        filterBy={() => true}
                                                        id="async-country"
                                                        labelKey="name"
                                                        ref={this.typeaheadRefCountry}
                                                        minLength={2}
                                                        onSearch={this.handleCountrySearch}
                                                        onChange={this.setCountry}
                                                        options={formInputs.countries}
                                                        placeholder="Enter Country..."
                                                        inputProps={{ required: true }}
                                                        onInputChange={this.handleCountryChange}
                                                        onBlur={this.handleCountryChange}
                                                    ></AsyncTypeahead>
                                                )} */}
                                            </Col>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <div style={{ textAlign: "center", padding: "15px 5px" }}>
                                        {formInputs.paymentMethodType === "2" &&
                                            <Button
                                                variant="outline-primary"
                                                type="button"
                                                className={css(styles.buttonClass)}
                                                onClick={this.saveNewCard}
                                                disabled={this.state.validated}
                                            >
                                                {"Save Card"}
                                            </Button>
                                        }
                                    </div>
                                </Row>
                            </Col>
                        }
                    </Row>
                </div>
            </div>
        );
    }
}

const style = StyleSheet.create({
    header: {
        background: 'linear-gradient(to right, #4969D6, #0061ef)',
        padding: '15px',
        display: 'flex',
        boxShadow: '0px 1px 4px 0px rgba(204,204,204,0.8)',
        alignItems: "center"
    },
    title: {
        color: "white",
        fontSize: "18px",
        lineHeight: "16px",
        display: "flex",
        flex: "1",
        alignItems: "center",
        textTransform: "uppercase",
    },
    divContainer: {
        display: "flex",
    },
    divIcon: {
        display: "flex",
        flex: "1",
        alignItems: "center",
        justifyContent: "flex-end",
    },
    iconsMenu: {
        cursor: "pointer",
    },
});

export default connect(
    (store) => {
        return {
            profileData: store.dashboard.profileData,
        };
    },
    (dispatch) => {
        return {

        };
    }
)(PayementMethods);
